import React from 'react'
import { Box, Card, Button } from '@mui/material'
import { Embroidery, PartialActionDispatch, PartialShoesActionDispatch, StateObj } from 'src/types'
import { initialEmbroideryState } from 'src/features/atoms/glove/japan/slice'
import { useLocale } from 'src/locales/useLocale'
export const ADD_EMBROIDERY = 'addEmbroideries'
export const REMOVE_EMBROIDERY = 'RemoveEmbroideries'

type Props = {
  embroideries: Embroidery[]
  positionObjects: StateObj[]
  dispatch: PartialActionDispatch | PartialShoesActionDispatch
}

export const EmbroideryFormUpDown: React.FC<Props> = ({ embroideries, positionObjects, dispatch }) => {
  const handleAddForm = () =>
    dispatch({
      type: ADD_EMBROIDERY,
      embroideries: embroideries.concat({ ...initialEmbroideryState, id: embroideries.length })
    })
  const handleRemoveForm = () =>
    dispatch({
      type: REMOVE_EMBROIDERY,
      embroideries: embroideries.filter((prev) => prev.id !== embroideries.length - 1)
    })
  const existEmptyContentsEmbroidery = embroideries.some((e) => e.position.value !== 'unselected' && e.content.trim().length === 0)
  const canIncrease = embroideries.length < positionObjects.length
  const { t } = useLocale()

  return (
    <Box mb={2}>
      <Card>
        <Box display="flex" justifyContent="center" my={1}>
          <Button onClick={handleAddForm} disabled={!canIncrease || existEmptyContentsEmbroidery} variant="outlined" style={{ marginRight: '4px' }}>
            ＋
          </Button>
          <Button onClick={handleRemoveForm} disabled={embroideries.length === 0} variant="outlined" style={{ marginLeft: '4px' }}>
            ー
          </Button>
        </Box>
        <Box pl={3} textAlign="left" color={'blue'} fontSize={'12px'}>
          {t.DESCRIBE_EMBROIDERY_PLUS_BUTTON}
        </Box>
        <Box pl={3} textAlign="left" color={'blue'} mb={1} fontSize={'12px'}>
          {t.DESCRIBE_EMBROIDERY_MINUS_BUTTON}
        </Box>
      </Card>
    </Box>
  )
}
